var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 2a6.59 6.59 0 00-4.734 2.001l-.575.588-.574-.588A6.589 6.589 0 006.685 2a6.593 6.593 0 00-4.734 2.001c-2.602 2.668-2.602 7.033.001 9.701l8.608 8.822a1.99 1.99 0 001.431.604c.52 0 1.04-.201 1.432-.604l8.608-8.822c2.603-2.668 2.603-7.033 0-9.701A6.587 6.587 0 0017.3 2",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconHeartFilled;